export default __webpack_public_path__ + "static/media/view-dark.5318f5f3.svg";